import moment from 'moment'
import { TABLA_POSIBLES_ARRIBOS } from '../../../../../config/tables'
import { getColumnasCodigosDeCupo } from '../../../../Cupos/containers/consultaCodigoDeCupos/actions/constantesConsultaCodigoDeCupos'
import { CodigoDeCupo } from '../../../../../models/cupo/codigoDeCupo'

export function parseDataPosibleArribo (data) {
  const parsedData = []
  const hoy = moment(new Date()).format('YYYY-MM-DD')

  if (data) {
    for (const entry of data) {
      if (entry.fechaCupo === hoy) {
        if (entry.arribo === 'En Viaje' || (entry.estadoCupoStopq === '' && !entry.estadoCupoStopq.startsWith('Consum'))) {
          const estado = entry.arribo === 'En Viaje' ? entry.arribo : 'Sin consumir'
          const dataCTG = {
            estado: estado,
            estadoCupoStopq: entry.estadoCupoStopq
          }
          parsedData.push({ ...entry, estado: estado, dataCTG: dataCTG })
        } else if (entry.arribo === 'Rechazado' || entry.arribo === 'Rechazo administrativo') {
          const dataCTG = {
            estado: entry.arribo,
            estadoCupoStopq: entry.estadoCupoStopq
          }
          parsedData.push({ ...entry, estado: entry.arribo, dataCTG: dataCTG })
        }
      } else if (entry.arribo === 'En Viaje' || entry.arribo === 'Rechazado' || entry.arribo === 'Rechazo administrativo' || entry.arribo === 'Abandono') {
        const dataCTG = {
          estado: entry.arribo,
          estadoCupoStopq: entry.estadoCupoStopq
        }
        parsedData.push({ ...entry, estado: entry.arribo, dataCTG: dataCTG, entry: entry })
      }
    }
  }
  return parsedData
}

export function getDataPosiblesArribos (fechaD, fechaH) {
  return (dispatch) => {
    CodigoDeCupo.getDataTablaConsultaCodigoDeCuposFiltrada(fechaD, fechaH, null, null)
      .then((data) => {
        const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
        return dispatch({ type: 'RECEIVE_POSIBLES_ARRIBOS', data, fecha })
      })
  }
}

export function cargarTablaPosiblesArribos (data, rol, filtroInicial) {
  return (dispatch) => {
    const d = parseDataPosibleArribo(data)
    // const displayFechaN = false
    const textRowCount = 'Cantidad: '
    const customToolbar = null
    const columnas = getColumnasCodigosDeCupo(rol)
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: columnas,
        data: d,
        title: `Códigos de cupo`,
        isLoading: false,
        fixed2Decimales: false,
        extraOptions: {
          customToolbar,
          print: false,
          pagination: false,
          tableBodyMaxHeight: '499px',
          showRowCount: true,
          textRowCount,
          filtroInicial
        }
      },
      id: TABLA_POSIBLES_ARRIBOS
    })
  }
}

export function actualizarPosiblesArribos (fechaD, fechaH, cereal = null, rol = null, filtroInicial = null, arribo = null, actualiza = false) {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_POSIBLES_ARRIBOS
    })

    const posiblesArribos = state.dashboard.posiblesArribos || null

    if (posiblesArribos && cereal && !actualiza) {
      const d = posiblesArribos.filter((c) => c.cereal === cereal)
      dispatch(cargarTablaPosiblesArribos(d, rol, filtroInicial))
    } else {
      CodigoDeCupo.getDataTablaConsultaCodigoDeCuposFiltrada(fechaD, fechaH, cereal, arribo)
        .then((data) => {
          const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
          dispatch({ type: 'RECEIVE_POSIBLES_ARRIBOS', data, fecha })
          dispatch(cargarTablaPosiblesArribos(data, rol, filtroInicial))
        })
    }
  }
}
